﻿import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SessionStorageService } from '../../session-storage/session-storage.service';
import { SessionAuthData } from '../../interfaces/session-auth-data.interface';
import { SessionableCommonDataModel } from '../../sessionable-common-data.model';
import { SessionDataModel } from '@app/shared/services/session/shared/session/models/session-data.model';

@Injectable()
export class SessionAuthDataModel extends SessionableCommonDataModel implements SessionAuthData {

  private _token: string;
  private _expires: Date;
  private _expirationSeconds: number;
  private _authenticated: Subject<void> = new Subject<void>();
  private _dashboardSsnToFilterBy: string;
  private _dashboardNameToFilterBy: string;
  private _dashboardBorrowerIdToFilterBy: string;
  private _isMultiBorrowerAccount: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(protected sessionStorageService: SessionStorageService) {
    super(sessionStorageService);
  }

  public populate(model?: SessionAuthDataModel): SessionAuthDataModel {
    this._token = model ? model._token : '';
    this._expires = model ? model._expires : new Date();
    this._expirationSeconds = model ? model._expirationSeconds : 0;
    this._dashboardSsnToFilterBy = model ? model._dashboardSsnToFilterBy : '';
    this._dashboardNameToFilterBy = model ? model._dashboardNameToFilterBy : '';
    this._dashboardBorrowerIdToFilterBy = model ? model._dashboardBorrowerIdToFilterBy : '';
    return this;
  }

  protected map(model: SessionDataModel): SessionAuthDataModel {
    return (model as any)._authData;
  }

  protected save(setter: (model: SessionAuthDataModel) => void): void {
    super.save(setter);
  }

  public get isMultiBorrowerAccount(): BehaviorSubject<boolean> {
    return this._isMultiBorrowerAccount;
  }

  public get authenticated(): Subject<void> {
    return this._authenticated;
  }

  public set token(value: string) {
    this._token = value;
    this._authenticated.next();
    this.save(x => x._token = value);
  }

  public get token(): string {
    return this._token;
  }

  public set expires(value: Date) {
    this._expires = value;
    this.save(x => x._expires = value);
  }

  public get expires(): Date {
    return this._expires;
  }

  public set expirationSeconds(value: number) {
    this._expirationSeconds = value;
    this.save(x => x._expirationSeconds = value);
  }

  public get expirationSeconds(): number {
    return this._expirationSeconds;
  }

  // These are for when we have shared accounts and need to prompt
  // the user post-login to determine their identity. Based on that
  // identity, we filter out loans that they are not associated with.
  public set dashboardSsnToFilterBy(value: string) {
    this._dashboardSsnToFilterBy = value;
    this.save(x => x._dashboardSsnToFilterBy = value);
  }

  public get dashboardSsnToFilterBy(): string {
    return this._dashboardSsnToFilterBy;
  }

  public set dashboardNameToFilterBy(value: string) {
    this._dashboardNameToFilterBy = value;
    this.save(x => x._dashboardNameToFilterBy = value);
  }

  public get dashboardBorrowerIdToFilterBy(): string {
    return this._dashboardBorrowerIdToFilterBy;
  }

  public set dashboardBorrowerIdToFilterBy(value: string) {
    this._dashboardBorrowerIdToFilterBy = value;
    this.save(x => x._dashboardBorrowerIdToFilterBy = value);
  }

  public get dashboardNameToFilterBy(): string {
    return this._dashboardNameToFilterBy;
  }
}
